export default {
  init: function () {
    return this.xf['@@transducer/init']();
  },
  result: function (result) {
    return this.xf['@@transducer/result'](result);
  }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/ramda/es/internal/_xfBase.js
// module id = ../node_modules/ramda/es/internal/_xfBase.js
// module chunks = 5